const MyCareerBonuses = () => {
    return (
        <div>
            <h1>My Career Bonuses</h1>
        </div>
    );
};

export default MyCareerBonuses;
